import { Avatar } from '@mui/material';
import Icon from '@mdi/react';

type ProfiePictureAvatarProps = {
  uri?: string | null;
  fallbackIcon: string;
  whiteBackground?: boolean;
};

export const AvatarWithFallback: React.FC<ProfiePictureAvatarProps> = ({ uri, fallbackIcon, whiteBackground }) =>
  uri ? (
    <Avatar
      sx={(theme) => ({
        height: theme.spacing(6),
        width: theme.spacing(6),
        maxWidth: theme.spacing(6),
      })}
      alt="Profile picture"
      src={uri}
    />
  ) : (
    <Avatar
      sx={(theme) => ({
        height: theme.spacing(6),
        width: theme.spacing(6),
        maxWidth: theme.spacing(6),
        '& svg': {
          color: theme.palette.rexelEnergy.ctaBlue,
        },
        backgroundColor: whiteBackground ? theme.palette.common.white : theme.palette.background.default,
      })}
    >
      <Icon path={fallbackIcon} size={1} />
    </Avatar>
  );
